<template>
  <div>
    <!-- 头部部分 支出明细-->
    <div class="head">
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item  prop="userId" v-if="adminShowSpecial">
          <el-cascader
            :placeholder="$t('app.payList.form.agent')"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="orderId">
         <el-input v-model="queryParams.orderId" :placeholder="$t('app.payList.form.orderId')" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item  prop="productName">
          <el-input v-model="queryParams.productName" :placeholder="$t('app.payList.form.packageName')" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateRange"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('app.payList.form.startDate')"
            :end-placeholder="$t('app.payList.form.endDate')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
          <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
          <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['person:userAccount:export']"> {{ $t('app.common.export') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 内容部分 -->
    <div class="table">
      <el-table :data="tableData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
        <el-table-column type="index" :label="$t('app.payList.table.serialNumber')" align="center" width="60px"></el-table-column>
        <el-table-column prop="orderId" :label="$t('app.payList.table.orderId')" align="center" width="220px"></el-table-column>
        <el-table-column prop="username" :label="$t('app.payList.table.nickname')" align="center" width="180px" v-if="adminShow"></el-table-column>
        <el-table-column prop="company" :label="$t('app.payList.table.agent')" align="center" width="260px"></el-table-column>
        <el-table-column prop="number" :label="$t('app.payList.table.cardCount')+' / PCS'" align="center" width="120px"></el-table-column>
        <el-table-column prop="money" :label="$t('app.payList.table.expendAmount')+' / 元'" align="center" width="140px" :formatter="formatMoney"></el-table-column>
        <el-table-column prop="accountAmount" :label="$t('app.payList.table.accountBalance')+' / 元'" align="center" width="140px" :formatter="formatMoney"></el-table-column>
        <el-table-column prop="orderResult" :label="$t('app.payList.table.orderResult')" align="center" width="180px">
          <template slot-scope="{row}">
            <span v-if="row.status == '2'" class="result-c" @click="pendingDialig(row)">{{ $t('app.payList.orderResult.pending') }}：{{row.number}}</span>
            <span v-if="row.status != '2'" class="result-c" @click="successDialig(row)"> {{ $t('app.payList.orderResult.success') }}：{{row.successNum}}</span>
            <span v-if="row.status != '2'" class="result-s" @click="failDialig(row)">{{ $t('app.payList.orderResult.failed') }}：{{row.failNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productName" :label="$t('app.payList.table.packageName')" align="center"></el-table-column>
        <el-table-column prop="payTime" :label="$t('app.payList.table.createTime')" align="center" width="160"></el-table-column>
        <el-table-column prop="remark" :label="$t('app.payList.table.remark')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="reason" :label="$t('app.payList.table.failReason')" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <div class="tc-class">
      <el-dialog :title="$t('app.payList.dialog.title')" :visible.sync="dialogVisible" width="750px" v-dialogDrag:before-close="handleClose">
        <div class="dialog-toolbar">
          <el-input
            v-model="dialogIccid"
            placeholder="ICCID"
            clearable
            class="dialog-search-input"
            @keyup.enter.native="dialogSearch"
          ></el-input>
          <div class="dialog-toolbar-btns">
            <el-button type="primary" icon="el-icon-search" @click="dialogSearch">{{ $t('app.common.search') }}</el-button>
            <el-button type="primary" icon="el-icon-download" @click="dialogExport">{{ $t('app.common.export') }}</el-button>
          </div>
        </div>
        <el-table :data="dialogTableData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}" style="height: 300px;overflow-y:auto;">
          <el-table-column prop="iccid" label="ICCID" align="center" width="185px"></el-table-column>
          <el-table-column prop="createTime" :label="$t('app.payList.dialog.table.orderTime')" align="center"></el-table-column>
          <el-table-column prop="money" :label="$t('app.payList.dialog.table.amount')" align="center"></el-table-column>
          <el-table-column prop="remark" :label="$t('app.payList.dialog.table.reason')" align="center"></el-table-column>
        </el-table>
        <div class="block" style="margin-top: 30px;">
          <el-pagination
            @size-change="dialoghandleSizeChange"
            @current-change="dialoghandleCurrentChange"
            :current-page="dialogPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="dialogPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dialogTotal"
          ></el-pagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { accountList ,exportAccount} from "@/api/api.js";//扣款明细
import { assetCardList } from "@/api/api.js";//扣款明细
import { assetInfoExport } from "@/api/api.js";//导出
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  data() {
    return{
      queryParams:{},
      dateRange:[],
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      dialogVisible:false,
      dialogTableData:[],
      dialogPage: 1,
      dialogPageSize: 20,
      dialogTotal:0,
      orderId:"",
      orderStatus:"",
      dialogIccid:"",
      agentTree:[],
    }
  },
  computed: {
    adminShowSpecial() {
      return this.$store.getters.user.userType =='1' || this.$store.getters.user.userId == this.$store.getters.xrsUserId
    },
    adminShow() {
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    // 金额统一保留两位小数（100 -> 100.00，100.2 -> 100.20）
    formatMoney(row, column, cellValue){
      if(cellValue === null || cellValue === undefined || cellValue === '') return cellValue;
      return Number(cellValue).toFixed(2);
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
					...this.addDateRange(this.queryParams, this.dateRange),
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      params.model.payType = "2"
      accountList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
        payType:'2'
      };
      exportAccount(params).then(res=>{
        this.$notify.info({
          title: this.$t('app.common.tip'),
          message: this.$t('app.payList.notify.exportSuccess'),
          duration: 1000,
          offset:30
        });
      })

    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.dateRange = [],
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 成功的弹窗数据
    successDialig(row){
      this.dialogVisible = true;
      this.orderId = row.orderId;
      this.dialogPage = 1;
      this.dialogIccid = "";
      this.orderStatus = 1;
      this.DialigData(this.orderId,this.orderStatus)
    },
    // 失败的弹窗数据
    failDialig(row){
      this.dialogVisible = true;
      this.orderId = row.orderId;
      this.dialogPage = 1
      this.dialogIccid = "";
      this.orderStatus = 0;
      this.DialigData(this.orderId,this.orderStatus )
    },
    //待处理的
    pendingDialig(row){
      this.dialogVisible = true;
      this.orderId = row.orderId;
      this.dialogPage = 1
      this.dialogIccid = "";
      this.orderStatus = 2;
      this.DialigData(this.orderId,this.orderStatus ) 
    },
    handleClose(){
      this.dialogVisible = false;
    },
    dialoghandleSizeChange(dialogPageSize){
      this.dialogPageSize = dialogPageSize;
      this.DialigData(this.orderId,this.orderStatus)
    },
    dialoghandleCurrentChange(dialogPage){
      this.dialogPage = dialogPage;
      this.DialigData(this.orderId,this.orderStatus)
    },
    DialigData(orderId,status){
      let params = {
        model:{
          orderId:orderId,
          status:status,
          iccid:this.dialogIccid
        },
        page: this.dialogPage,
        pageSize: this.dialogPageSize,
      };
      assetCardList(params).then(res=>{
        this.dialogTableData = res.data.data.records;
        this.dialogTotal = res.data.data.total;
      })
    },
    dialogSearch(){
      this.DialigData(this.orderId,this.orderStatus)
    },
    dialogExport(){
      let params = {
        iccid:this.dialogIccid,
        orderId:this.orderId,
        status:this.orderStatus
      }
      this.$alert(this.$t('app.payList.dialog.confirmExportMsg'), this.$t('app.payList.dialog.exportTitle'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        assetInfoExport(params).then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: this.$t('app.common.success'),
              message: this.$t('app.payList.notify.exportListSuccess'),
              type: "success",
              offset:30
            });
          }
        })
      }).catch(() => {});
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList({self:'1'}).then(res => {
        this.agentTree = res.data.data;
      });
    },
  },
  created() {
    this.initData();
    if(this.adminShowSpecial){
      this.handleAgentTreeList();
    }
  },
  mounted() {

  },

};
</script>

<style scoped lang="less">

.result-c{
  color: #15C392;
  cursor: pointer;
}
.result-s{
  color: #FF0000;
  cursor: pointer;
  margin-left:10px
}
.iclass-text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}
// 弹窗顶部工具栏：输入框与按钮同一行，两端对齐
.dialog-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  .dialog-search-input {
    width: 260px;
    flex: 0 0 260px;
  }

  .dialog-toolbar-btns {
    display: flex;
    align-items: center;

    .el-button + .el-button {
      margin-left: 10px;
    }
  }
}
</style>


